import { ImpactType, ProjectSubType, ProjectType } from '@prisma/client';
import { getBaseApiV2Url } from '../urls';

interface CreateTestProjectInput {
  email: string;
  title: string;
  slug: string;
  fundedSince?: string | Date;
  apiBaseUrl: string;
  headers: Record<string, string>;
}

interface CreateTestProjectResponse {
  result?: {
    data?: {
      id: number;
      title: string;
      slug: string;
      fundedSince: string | null;
    };
  };
  access_token?: string;
}

export async function createTestProject({
  email,
  title,
  slug,
  fundedSince,
  apiBaseUrl,
  headers,
}: CreateTestProjectInput) {
  const tokenResponse = await fetch(`${apiBaseUrl}/test-auth/generate-auth-token-set`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...headers },
    body: JSON.stringify({ email }),
  });

  if (!tokenResponse.ok) {
    throw new Error(`Failed to get auth token: ${await tokenResponse.text()}`);
  }

  const tokenData = (await tokenResponse.json()) as CreateTestProjectResponse;
  const accessToken = tokenData.access_token;

  if (!accessToken) {
    throw new Error('No access token returned when creating test project');
  }

  const createResponse = await fetch(`${getBaseApiV2Url(apiBaseUrl)}/v2/projects.admin.create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      title,
      slug,
      impactType: ImpactType.TREES,
      projectType: ProjectType.REFORESTATION,
      projectSubType: ProjectSubType.GLOBAL_REFORESTATION,
      fundedSince: fundedSince instanceof Date ? fundedSince.toISOString() : fundedSince,
    }),
  });

  if (!createResponse.ok) {
    throw new Error(`Failed to create project: ${await createResponse.text()}`);
  }

  const projectData = (await createResponse.json()) as CreateTestProjectResponse;
  const project = projectData.result?.data;

  if (!project) {
    throw new Error('No project data returned when creating test project');
  }

  return project;
}
